<template>
  <div style="height: 650px">

    <el-col :span="22" v-for="item in pictureItems" style="margin-top: 20px;margin-left: 20px">
      <el-image :src="item.url"></el-image>
    </el-col>

  </div>
</template>

<script>
export default {
  name: "QclPictureView",
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data(){
    return{
      pictureItems:{}
    }
  },
  methods:{

    /*currentCheckChange(pageNo){
      this.query.pageNo=pageNo
      this.getPictureItems()
    },*/

    async getQclPictures() {
      let {data: res} = await this.$axios.post('bus/picture/getQclPictures',this.parentData);
      if (res.code !== 0) {
        this.$message.error('获取【图片明细】失败')
      }
      this.pictureItems = res.data
    }

  },

  created() {
    this.getQclPictures()
  }

}
</script>

<style scoped>
.pageStyle{
  width: 100%;
  display: flex;
  justify-content:flex-end;
  margin: 20px 0
}

/deep/.el-table .el-table__cell{
  z-index: auto;
}
</style>